/*
  The whole installment methods is a third-party widgets,
  So there aren't a custom classes (as other components) to style them.
*/

salla-installment:empty {
  display: none;
}

/*
* Installment::Tabby
*/
#tabbyPromoWrapper {
  background: white;
  border-radius: 0.375rem;
  transition: box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 20px;
  border: unset !important;
  font-weight: 500;

  .salla-y & {
    border: 1px solid var(--color-grey-dark);
    border-radius: 12px
  }

  &:hover {
    box-shadow: 0 0 #0000, 0 0 #0000, 5px 10px 30px #2B2D340D;
  }

  #tabbyPromo {
    * {
      font-family: var(--font-main);
    }

    >div>div {
      max-width: none;
      //padding: 15px;
      box-shadow: none;
      border: none;
    }

    .tabby-promo-snippet {
      max-width: 100%;
      min-height: 100px;
      padding: 18px 20px;
      // border-color: var(--color-grey-dark);
      border: none !important;


      &__text,
      &__link {
        font-size: var(--font-sm);
        color: var(--color-text) !important;
      }

      &__link {
        font-weight: bold;
      }
    }
  }
}

.tabby-promo-wrapper {
  #tabby-promo {
    font-family: var(--font-main) !important;

    .tabby-promo {
      &__feature-title {
        font-size: var(--font-md);
      }

      &__feature-desc {
        font-size: var(--font-sm);
        line-height: 20px;
      }
    }
  }
}

/*
* Installment::Tamara & Spotii
*/
.tamara-product-widget {
  margin-bottom: 20px;
}

.tamara-product-widget,
.spotii-wrapper {
  min-height: 100px;
  position: relative;
  color: var(--main-text-color);
  font-size: var(--font-sm);
  line-height: 1.25;
  padding: 20px 20px 20px 115px !important;
  background: white;
  border-radius: 0.375rem;
  transition: box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border: unset !important;
  font-family: inherit !important;
  font-weight: 500;
  .salla-y & {
    border-radius: 12px;
    border: 1px solid var(--color-grey-dark);
  }

  &:hover {
    box-shadow: 0 0 #0000, 0 0 #0000, 5px 10px 30px #2B2D340D;
  }

  .spotii-logo {
    float: left;
    margin: 0 0 0 -75px;
  }
}

.ltr .tamara-product-widget,
.ltr .spotii-wrapper {
  text-align: left;
  padding: 18px 100px 18px 20px !important;

  .spotii-logo {
    float: right;
    margin: 0 -75px 0 0;
  }

  .spotii-product-widget {
    text-align: left !important;
  }
}

.spotii-wrapper {
  margin-bottom: 20px;

  .spotii-promo {
    font-size: var(--font-md);
  }

  .spotii-product-widget {
    font-size: var(--font-sm) !important;
    margin-top: 10px;
  }
}

.tamara-product-widget {
  .tamara-logo {
    position: absolute;
    left: 20px !important;
    top: 35px !important;
    margin: 0 !important;
    height: 24px !important;

    .ltr & {
      right: 20px !important;
      left: auto !important;
    }
  }

  span {
    font-family: var(--font-main);
    font-size: var(--font-sm);
    color: var(--color-text);

    &:last-child {
      display: block;
      position: relative;
      margin-top: 8px;
    }
  }
}

.tamara-popup {
  &__wrap {
    overflow: auto !important;
  }
}

// mispay and madfu and emkan
// mispay, madfu, and emkan
.s-installment-mispay-wrapper,
.s-installment-madfu-wrapper,
.s-installment-emkan-wrapper,
.s-installment-rajehi-wrapper {
  // font-family: "Noto Sans Arabic", sans-serif;
  font-size: 14px;
  text-align: right;
  padding: 20px;
  gap: 42px;
  direction: rtl;
  line-height: 22px;
  color: rgb(0, 0, 0);
  min-width: 100%;
  box-sizing: border-box;
  position: relative;
  background-color: white;
  border-radius: 10px;
  margin: 15px 0;
  display: flex;
  transition: box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.s-installment-mispay-wrapper:hover,
.s-installment-madfu-wrapper:hover,
.s-installment-emkan-wrapper:hover,
.s-installment-rajehi-wrapper:hover{
  box-shadow: 0 0 #0000, 0 0 #0000, 5px 10px 30px #2B2D340D;
}

.s-installment-mispay-content,
.s-installment-madfu-content,
.s-installment-emkan-content,
.s-installment-rajehi-content {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}


.ltr .s-installment-mispay-content,
.ltr .s-installment-madfu-content,
.ltr .s-installment-emkan-content,
.ltr .s-installment-rajehi-content{
  flex-direction: row;
}

.s-installment-mispay-content-text,
.s-installment-madfu-content-text,
.s-installment-emkan-content-text,
.s-installment-rajehi-content-text {
  color: var(--main-text-color);
  font-size: 14px;
  font-weight: 500;
  margin: 0 16px 0 0;
  width: 80%;
  // position: absolute;
  left: 14px;
  text-align: left;
}

.s-installment-mispay-content img,
.s-installment-madfu-content img,
.s-installment-emkan-content img,
.s-installment-rajehi-content img{
  height: 28px;
  width: 70px;
  display: inline-block;
  max-height: 100%;
  vertical-align: middle;
  fill: none;
  stroke: unset;
  width: auto;
  // position: absolute;
}

/* RTL Support */
.rtl .s-installment-mispay-content-text,
.rtl .s-installment-madfu-content-text,
.rtl .s-installment-emkan-content-text,
.rtl .s-installment-rajehi-content-text {
  right: 14px;
  text-align: right;
  margin: 0 0 0 16px;
}

.rtl .s-installment-mispay-content img,
.rtl .s-installment-madfu-content img,
.rtl .s-installment-emkan-content img,
.rtl .s-installment-rajehi-content img{
  left: 14px !important;
}

.ltr .s-installment-mispay-content img,
.ltr .s-installment-madfu-content img,
.ltr .s-installment-emkan-content img,
.ltr .s-installment-rajehi-content img {
  right: 14px !important;
}


.s-installment-rajehi-content img {
  width: 70px !important;
  height: 40px !important;;
}

.s-installment-emkan-content img {
  height: 35px !important;
}

